import React from 'react';
import Loader from "../../Parts/Loader";

const ResultLoaderSection = () => {
  return (
    <Loader type="color" size="large" />
  );
}

ResultLoaderSection.propTypes = {
};

export default ResultLoaderSection;



// WEBPACK FOOTER //
// ./src/components/DownloadHistory/sections/ResultLoaderSection.jsx